import React, { useState } from "react";
import { MarketingDashSVG } from "../MarketingDashSVG";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { Body, V3Body, V3Title } from "../Typography";
import { FAQSVG, MarketingFAQWrapper, QuestionsWrapper, QuestionWrapper, QuestionSVG, FAQTitle, FAQQuestionTitle } from "./MarketingFAQ.styles";

type QuestionProps = {
    question: JSX.Element,
    answer: JSX.Element,
    useV3Components?: boolean
}

const Question = ({ question, answer, useV3Components = false }: QuestionProps) => {
    const [open, setOpen] = useState(false);

    return <QuestionWrapper open={open} onClick={() => setOpen(!open)} useV3Components={useV3Components}>
        <QuestionSVG useV3Components={useV3Components}>
            {
                useV3Components ? <V3BodyGrey35><strong>{question}</strong></V3BodyGrey35> : <FAQQuestionTitle>{question}</FAQQuestionTitle>
            }
            <div>
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 1L7.67387 6.70122C7.3017 7.09959 6.6983 7.09959 6.32613 6.70122L1 1" stroke="#08162B" />
                </svg>
            </div>
        </QuestionSVG>
        {
            useV3Components ? <V3Body as="div">{answer}</V3Body> : <Body>{answer}</Body>
        }
    </QuestionWrapper>
}

type MarketingFAQProps = {
    questions: {
        question: string | JSX.Element,
        answer: string | JSX.Element,
    }[],
    useV3Components?: boolean
}

export const MarketingFAQ = ({ questions, useV3Components = false }: MarketingFAQProps) => {
    const TitleComponentToUse = useV3Components ? V3Title : FAQTitle;

    return <MarketingFAQWrapper>
        {
            !useV3Components && <>
                <div>
                    <MarketingDashSVG />
                </div>
                <FAQSVG src={"/authory_static_files/images/faq_background.svg"} />
            </>
        }
        <QuestionsWrapper>
            <TitleComponentToUse>Frequently Asked Questions</TitleComponentToUse>
            {
                questions.map((question, index) => <Question
                    key={index}
                    question={<>{question.question}</>}
                    answer={<>{question.answer}</>}
                    useV3Components={useV3Components}
                />)
            }
        </QuestionsWrapper>
    </MarketingFAQWrapper>
}